import ff from './ff';

export default class i12d { // カレンダー

static d_defs = {

/*
  DROP TABLE t_c60r;
  CREATE TABLE t_c60r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c60rb21f INTEGER,
    c60ri11s TEXT,
    c60rcx1i INTEGER,
    c60rcy1t TEXT,
    c60rcy1f INTEGER,
    c60rcz1i INTEGER
  );
  INSERT INTO t_c60r (_vsn, _ltt, c60rb21f, c60ri11s, c60rcx1i, c60rcy1t, c60rcy1f, c60rcz1i)
  VALUES (1, 1, 1, '2021', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c60r (_vsn, _ltt, c60rb21f, c60ri11s, c60rcx1i, c60rcy1t, c60rcy1f, c60rcz1i)
  VALUES (1, 1, 1, '2022', 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_c60r SET _fst = _key;
*/

  c60r: {
    0: {
      pfx: '年度',
      b_vsn: true,
      d_insFlds: {
        c60ri11i: '',
      },
      dd_fldDefss: {
        c60rb21f: { 
          pfx: 'c20m_key',
          type: 'Inp',
        },
        c60ri11s: {
          pfx: '対象年',
          type: 'Inp',
          n_col: 5,
        },
      },
    },
  },

/*
  DROP TABLE t_c600;
  CREATE TABLE t_c600 (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c600b21f INTEGER,
    c600br1k INTEGER,
    c600i11d TEXT,
    c600cx1i INTEGER,
    c600cy1t TEXT,
    c600cy1f INTEGER,
    c600cz1i INTEGER
  );
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 1, '2021-11-03', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 1, '2021-11-23', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 1, '2021-12-29', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 1, '2021-12-30', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 1, '2021-12-31', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 2, '2022-01-01', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 2, '2022-01-02', 9999, '2000-01-01 00:00:00', 1, 10);
  INSERT INTO t_c600 (_vsn, _ltt, c600b21f, c600br1k, c600i11d, c600cx1i, c600cy1t, c600cy1f, c600cz1i)
  VALUES (1, 1, 1, 2, '2022-01-03', 9999, '2000-01-01 00:00:00', 1, 10);
  UPDATE t_c600 SET _fst = _key;
*/

  c600: {
    0: {
      pfx: '日付',
      b_vsn: true,
      d_insFlds: {
        c600i11d: '',
      },
      dd_fldDefss: {
        c600b21f: { 
          pfx: 'c20m_key',
          type: 'Inp',
        },
        c600br1k: { 
          pfx: 'c60r_key',
          type: 'Inp',
        },
        c600i11d: {
          pfx: '対象日',
          type: 'PckDate',
        },
      },
    },
  },

};

};
